import { createAction } from "@reduxjs/toolkit";

export const apiCallBegan = createAction("api/callBegan");
export const apiCallSuccess = createAction("api/callBegan");
export const apiCallFailed = createAction("api/callBegan");
